import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { nowNCFilePerformanceConfig } from '@v2/pages/machines/navigation/config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const NCFIlePerformanceStack = createStackNavigator();

const NCFIlePerformanceNavigator = () => {
  return (
    <NCFIlePerformanceStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {nowNCFilePerformanceConfig.map(({ Component, name }) => (
        <NCFIlePerformanceStack.Screen key={name} name={name} component={Component} />
      ))}
    </NCFIlePerformanceStack.Navigator>
  );
};

export { NCFIlePerformanceNavigator };
